import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { RestaurantMap } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useRestaurantMap = (restaurantId: number, enabled = true) => {
  const branch = useBranchId();

  const isRestaurantIdValid =
    Number.isInteger(restaurantId) && restaurantId > 0;

  return useQuery<RestaurantMap>({
    enabled: enabled && isRestaurantIdValid,
    queryKey: ["restaurantMap", branch, restaurantId],
    queryFn: () => {
      if (!isRestaurantIdValid) return;
      return get2(
        `/internal/secure/pos/v1/restaurant/map/${branch}/${restaurantId}`
      );
    },
  });
};

export default useRestaurantMap;
